import { useEffect } from "react"
import { setFeatureState, cleanFeatureState } from "utils"
import type { MapboxGeoJSONFeature, Map } from "mapbox-gl"
import type { MapFeatureState } from "tes-types"

/**
 * Sets given Mapbox feature-state on the given feature.
 * Clears the state when feature changes.
 */
function useMapFeatureState({
  feature,
  map,
  state,
}: {
  feature: MapboxGeoJSONFeature | null
  map: Map | null
  state: MapFeatureState
}) {
  useEffect(() => {
    if (!map || !feature) return

    setFeatureState({ map, feature, state })

    return () => {
      cleanFeatureState({ map, feature, state })
    }
  }, [map, feature, state])
}

/**
 * Sets Mapbox's `hover` feature-state on the given feature.
 * Clears the state when the feature changes.
 */
export function useMapHoverFeatureState({
  feature,
  map,
}: {
  feature: MapboxGeoJSONFeature | null
  map: Map | null
}) {
  useMapFeatureState({ map, feature, state: "hover" })
}

/**
 * Sets Mapbox's `selected` feature-state on the given feature.
 * Clears the state when the feature changes.
 */
export function useMapSelectedFeatureState({
  feature,
  map,
}: {
  feature: MapboxGeoJSONFeature | null
  map: Map | null
}) {
  useMapFeatureState({ map, feature, state: "selected" })
}
